import Translate from "@casino/legacy/client/shared/i18n/Translate";
import React from "react";

const CreateAccountLinkBody: FC = ({ children }) => (
  <div className="flex gap-2 overflow-hidden flex-wrap justify-start items-center">
    <p className="text-sm leading-6 text-muted-foreground">
      <Translate id="profile.dont_have_an_account" />
    </p>
    {children}
  </div>
);

export default CreateAccountLinkBody;
